import {BasicTable, Layout, Text} from '@eitje/web_components'
import {COLUMNS} from './columns'
import {ROW_FORMATS} from '~/components/basic_table/components/rows'
import {t} from '~/initializers/i18n'
import {Environment} from '@eitje/api'
import '../../components/styles.less'

export const UserOrganisationBasicTable = ({user, organisation}) => {
	const {name} = organisation
	const environments = useCollectUserEnvironments(user, organisation)
	const data = environments.map(environment => ({environment, user}))

	return (
		<Layout gap={12} width="full" margin="24 - - -" direction="vertical">
			<Text bold fontSize={18}>
				{t('headers.organisation', {name})}
			</Text>
			<BasicTable name="organisation_table" data={data} columns={COLUMNS} textRows={ROW_FORMATS} />
		</Layout>
	)
}

const useCollectUserEnvironments = (user, organisation) => {
	const {environment_ids: organisationEnvironmentIds} = organisation
	const userEnvironmentIds = [...user.environment_ids, ...user.deleted_environment_ids]
	const matchingEnvironmentIds = organisationEnvironmentIds.filter(id => userEnvironmentIds.includes(id))

	return Environment.useWhere({id: matchingEnvironmentIds})
}
